import styled from 'styled-components/native'
import { SearchContainer, ButtonContainer } from '../SearchCard/style'

export const AddressSearchContainer = styled(SearchContainer)`
  padding-left: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin}px;
`
export const AddressButtonContainer = styled(ButtonContainer)`
  ${({ theme: { isSmallScreen } }) => isSmallScreen && 'justify-content: center;'}
  ${({ theme: { isBigScreen } }) => isBigScreen && 'right: 0;'}
  ${({ theme: { isBigScreen } }) => !isBigScreen && 'width: 100%;'}
  flex-grow: 0;
`
